export function UserLockoutsRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.UserLockouts', {
		url: '/admin/user_lockouts',
		controllerAs: 'vm',
		controller: UserLockoutsCtrl,
		templateUrl: '/ng/hub/User/Lockouts/UserLockoutsCtrl.html',
		permission: ['all'],
		resolve: {
			$title: () => 'UserLockouts page',
		},
	});
}

export class UserLockoutsCtrl {
	constructor(Api) {
		'ngInject';
		this.Api = Api;

		// setup user table
		this.columns = [
			{ field: 'last_attempt', label: 'Last Attempt', sortable: true },
			{ field: 'num_failures', label: 'Fails', sortable: true },
			{ field: 'fname', label: 'First', sortable: true },
			{ field: 'lname', label: 'Last', sortable: true },
			{ field: 'entity', label: 'Entity', sortable: true },
			{ field: 'ip_geo', label: 'Location', sortable: false },
			{ field: 'last_login', label: 'Last Login', sortable: true },
		];
		this.limit = 25;
		this.filters = {};
		this.actions = [{ label: 'Unlock', icon: null, callback: this.unlockUser.bind(this) }];
	}

	unlockUser(lockout) {
		this.Api.post(`/users/${lockout.user_id}/unlock`).then(
			() => {
				this.filters.cb = +new Date();
			},
			() => {}
		);
	}
}
